<template>
    <v-card-title class="grey lighten-3">
        <v-col cols="auto" class="py-0">
            <v-breadcrumbs :items="items" divider=">" large class="pa-0" />
        </v-col>
        <v-spacer />
        <v-col cols="auto" class="py-0">
            <v-btn @click="$emit('close')" icon><v-icon>mdi-close</v-icon></v-btn>
        </v-col>
    </v-card-title>
</template>

<script>
export default {
    props: ["program"],
    computed: {
        items() {
            const { categoryName, title } = this.program;
            return [{ text: categoryName }, { text: title }, { text: "신청서목록" }];
        },
    },
};
</script>

<style></style>
